import type { SFTPConfiguration } from "kubb";
import type React from "react";
import * as Yup from "yup";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";
import { yupRequiredString } from "../../../components/Forms/yupValidators";

export const SFTPExportConfigurationSchema = Yup.object().shape({
  host: yupRequiredString,
  username: yupRequiredString,
  password: yupRequiredString,
  port: Yup.number(),
  path: Yup.string(),
});

export const SFTPExportInitialValues: SFTPConfiguration = {
  host: "",
  port: 22,
  username: "",
  password: "",
  path: "/",
};

export default function SFTPExportConfigurationForm({
  namespace,
  disabled = false,
}: {
  namespace: string;
  disabled?: boolean;
}): React.ReactElement {
  const withNamespace = (fieldName: string): string => {
    return namespace ? `${namespace}.${fieldName}` : fieldName;
  };

  return (
    <>
      <h4>FTP Configuration</h4>
      <NewTextFormComponent
        fieldName={withNamespace("host")}
        label={{ label: "Host" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("port")}
        label={{ label: "Port" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("username")}
        label={{ label: "Username" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("password")}
        label={{ label: "Password" }}
        disabled={disabled}
        type={"password"}
      />
      <NewTextFormComponent
        fieldName={withNamespace("path")}
        label={{ label: "Remote path" }}
        disabled={disabled}
      />
    </>
  );
}
